/* ==========================================================================
   Virsaay — lazy films
   Any <video data-lazy-video> with <source data-src> children loads only when
   it first comes near the screen, plays while it is visible (clipped by any
   scrolling row it sits in) and pauses when it leaves. Under reduced motion
   nothing loads and the poster stands in. Adds .is-playing once frames flow.
   ========================================================================== */

(function () {
  'use strict';

  if (window.VirsaayLazyVideo) return;

  var reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function isReduced() {
    return reducedQuery.matches || (window.VirsaayMotion && window.VirsaayMotion.reduced === true);
  }

  function load(video) {
    if (video.dataset.lazyLoaded === 'true') return;
    Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function (source) {
      source.src = source.dataset.src;
    });
    video.dataset.lazyLoaded = 'true';
    video.load();
  }

  function sync(video) {
    if (video._vlvInView && !isReduced()) {
      load(video);
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
    } else if (!video.paused) {
      video.pause();
    }
  }

  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              entry.target._vlvInView = entry.isIntersecting;
              sync(entry.target);
            });
          },
          { rootMargin: '120px 0px', threshold: 0.1 }
        )
      : null;

  function videosIn(root) {
    var list = [];
    if (root.matches && root.matches('video[data-lazy-video]')) list.push(root);
    if (root.querySelectorAll) Array.prototype.push.apply(list, root.querySelectorAll('video[data-lazy-video]'));
    return list;
  }

  function init(root) {
    videosIn(root || document).forEach(function (video) {
      if (video._vlvBound) return;
      video._vlvBound = true;
      video.addEventListener('playing', function () {
        video.classList.add('is-playing');
      });
      if (observer) {
        observer.observe(video);
      } else {
        video._vlvInView = true;
        sync(video);
      }
    });
  }

  function release(root) {
    videosIn(root).forEach(function (video) {
      if (observer) observer.unobserve(video);
      video.pause();
      video._vlvBound = false;
    });
  }

  window.VirsaayLazyVideo = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    release(event.target);
  });

  var onReducedChange = function () {
    videosIn(document).forEach(sync);
  };
  if (reducedQuery.addEventListener) reducedQuery.addEventListener('change', onReducedChange);
  else if (reducedQuery.addListener) reducedQuery.addListener(onReducedChange);
})();
